import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import userReducers from './users';
import loginPopReducers from './login-pop';
import classInfoReducers from './class-info';
import socketStatusReducers from './socket-status';
import uiReducers from './ui';
import menusReducers from './menus';
import teachingBlockReducers from './teaching-block';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['users'], // 只持久化 users reducer
};
const rootReducer = combineReducers({
  users: userReducers,
  loginPop: loginPopReducers,
  classInfo: classInfoReducers,
  socket: socketStatusReducers,
  menus: menusReducers,
  ui: uiReducers,
  teachingBlock: teachingBlockReducers,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  devTools: import.meta.env.NODE_ENV !== 'production',
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});
export const persistor = persistStore(store);
export default store;
